const API_BASE_URL = "https://user.vr-cpr.com";
//const API_BASE_URL = "http://localhost:5210"; // Test mode
export { API_BASE_URL };
